<script>
    import { scrollMixin } from '@dreipol/vue-ui/src/mixins';
    import vuexViewportMixin from 'framework/vuex/modules/viewport/mixin';
    import { importStyleguidePage } from 'framework/styleguide/page/import-styleguide-page';

    export default {
        components: {
            ...importStyleguidePage('StyPage'),
        },
        mixins: [
            vuexViewportMixin,
            scrollMixin,
        ],
    };
</script>
